import { Fragment, useEffect, useState } from 'react'
import HomeSkeleton from '../../components/skeleton/home/homeSkeleton'
import { TopBar } from '../../widgets'
import { BannerCarousel, BarcodeIconWithModal, NoticePopupModal, WelcomePopupModal } from '../../features'
import { GnbFooter, ShowEnvBadge, DividerThin } from "../../shared"
import { requestStandardVersion, storedFCMTokenForMobile } from '../../utils'
import { useNavigate } from 'react-router-dom'
import { centerCardList, programCardList } from "./model"
import YogaCenterCarousel from './yogaCenterCarousel'
import AppDownBottomSheet from './appDownBottomSheet'

const Home = () => {
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    const [imageLoaded, setImageLoaded] = useState<boolean>(false);
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [isAppDownOpen, setIsAppDownOpen] = useState<boolean>(false);
    const [barCodeModalOpen, setBarCodeModalOpen] = useState<boolean>(false);
    const [wasWelcomePopupShown, setWasWelcomePopupShown] = useState<boolean>(false);

    const handleWelcomePopupVisibilityChange = (isVisible: boolean) => {
        if (isVisible) {
            setWasWelcomePopupShown(true);
        }
    };

    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > (65 + Number())) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    const getIsMobileAndIsWebAndNotApp = () => {
        const isInApp = (window?.native_yoga_bridge || window?.webkit?.messageHandlers?.native_yoga_bridge);
        return !isInApp;
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
    }, []);
    useEffect(() => {
        storedFCMTokenForMobile()
        requestStandardVersion()
    }, [])
    useEffect(() => { imageLoaded && setIsInitLoading(false) }, [imageLoaded])

    useEffect(() => {
        setIsAppDownOpen(getIsMobileAndIsWebAndNotApp())
    }, [])

    return <>
        {isInitLoading && <HomeSkeleton />}
        <ShowEnvBadge />
        <TopBar overOnClicks={{ left: () => setBarCodeModalOpen(curr => !curr) }} type='logo' thema={scrolled ? 'dark' : 'white'} position='fixed' styles={{ fixedTopDiv: { height: 0 } }} />
        <BannerCarousel setImageLoaded={setImageLoaded} />
        <div style={{ paddingInline: '20px', paddingTop: '40px', marginBottom: '40px' }}>
            <div style={{ marginBottom: 32 }} >
                <div className='sub-title/st3 base/black' style={{ marginBottom: 20 }}>
                    프라이빗 프로그램
                </div>
                <div style={{ marginBottom: 32 }}>
                    <img src='https://img.positivehotel.io/2025/10/17/IMG_1795.jpg' width={'100%'} style={{ aspectRatio: '1/1', marginBottom: 12, borderRadius: 4 }} onClick={() => navigate('/event/24')} />
                    <div>
                        <div className='sub-title/st5 base/black' style={{ marginBottom: 8 }}>
                            전문 코치와 함께하는 요가 PT
                        </div>
                        <div className='body/b3 secondary/s850'>
                            온전히 나에게 집중하는 1:1 요가로 매일의 순간을 더 단단하게 채워보세요
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style={{ marginBottom: 42 }}>
            <div className='sub-title/st3 base/black' style={{ paddingInline: 20, marginBottom: 20 }}>
                파지티브호텔 스튜디오
            </div>
            <YogaCenterCarousel carouselList={centerCardList} />
        </div>

        <div className='secondary/s500' style={{ backgroundColor: 'var(--secondarys100)', padding: '40px 20px', marginTop: 80, display: 'flex', flexDirection: 'column', gap: 12, fontSize: 11 }}>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    상호명
                </div>
                <div>
                    파지티브호텔 요가 선릉
                </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    대표자명
                </div>
                <div>
                    정형록
                </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    사업자등록번호
                </div>
                <div>
                    113-85-42244
                </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    사업장 주소
                </div>
                <div>
                    서울특별시 강남구 테헤란로 407, 1층 일부 이케이타워(삼성동)
                </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    유선번호
                </div>
                <div>
                    02-6203-0677
                </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
                <div className='secondary/s850'>
                    통신판매업 신고번호
                </div>
                <div>
                    2025-서울강남-04985호
                </div>
            </div>
        </div>
        {!isInitLoading && !getIsMobileAndIsWebAndNotApp() && (
            <WelcomePopupModal onVisibilityChange={handleWelcomePopupVisibilityChange} />
        )}
        {!isInitLoading && !getIsMobileAndIsWebAndNotApp() && !wasWelcomePopupShown && (
            <NoticePopupModal />
        )}
        <GnbFooter activeButton='home' />
        <AppDownBottomSheet isOpen={isAppDownOpen} setIsOpen={setIsAppDownOpen} />
        <BarcodeIconWithModal isOnlyModal propsOpen={barCodeModalOpen} setPropsState={setBarCodeModalOpen} />
    </>
}

export default Home
